var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootsteps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60896 15.028L7.7559 14.3075C8.14245 14.1777 8.5584 14.4024 8.66068 14.7971C8.72372 15.0404 8.7941 15.297 8.8726 15.5685C9.13429 16.4728 8.6342 17.4224 7.74155 17.722L7.69317 17.7382C6.81998 18.0312 5.8686 17.6013 5.51193 16.7521C5.41025 16.51 5.29977 16.2459 5.1831 15.9654C5.02637 15.5885 5.2221 15.1578 5.60896 15.028Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57996 7.6768C7.85816 9.1518 7.74035 9.99086 7.78605 11.1637C7.79824 11.4769 7.60405 11.7611 7.30688 11.8608L4.41637 12.8309C4.06117 12.9501 3.67497 12.7699 3.53762 12.4213C3.10443 11.3219 2.69884 10.2487 2.41717 9.40942C1.4524 6.53466 2.25644 4.64548 3.85074 4.11043C5.44508 3.57538 7.09312 5.0957 7.57996 7.6768Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1419 13.0245L12.995 12.3039C12.6084 12.1742 12.1925 12.3988 12.0902 12.7936C12.0271 13.0368 11.9568 13.2934 11.8783 13.565C11.6166 14.4693 12.1167 15.4189 13.0093 15.7184L13.0577 15.7347C13.9309 16.0277 14.8823 15.5978 15.2389 14.7486C15.3406 14.5064 15.4511 14.2423 15.5678 13.9618C15.7245 13.585 15.5288 13.1543 15.1419 13.0245Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1707 5.67316C12.8925 7.14816 13.0104 7.98722 12.9647 9.16001C12.9525 9.47324 13.1467 9.75744 13.4438 9.85718L16.3343 10.8272C16.6895 10.9464 17.0757 10.7663 17.2131 10.4177C17.6463 9.31828 18.0519 8.24501 18.3335 7.40578C19.2983 4.53098 18.4943 2.64184 16.9 2.10675C15.3056 1.57174 13.6576 3.09209 13.1707 5.67316Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootsteps);
export default __webpack_public_path__ + "static/media/footsteps.0a77f7795c396261c1912d8c3d3a2810.svg";
export { ForwardRef as ReactComponent };